export interface Country {
    id: string;
    label: string;
    code: string;
}

export const countries: Country[] = [
    { id: 'AD', label: 'Andorra', code: 'AD' },
    { id: 'AE', label: 'United Arab Emirates', code: 'AE' },
    { id: 'AF', label: 'Afghanistan', code: 'AF' },
    { id: 'AG', label: 'Antigua and Barbuda', code: 'AG' },
    { id: 'AI', label: 'Anguilla', code: 'AI' },
    { id: 'AL', label: 'Albania', code: 'AL' },
    { id: 'AM', label: 'Armenia', code: 'AM' },
    { id: 'AO', label: 'Angola', code: 'AO' },
    { id: 'AQ', label: 'Antarctica', code: 'AQ' },
    { id: 'AR', label: 'Argentina', code: 'AR' },
    { id: 'AS', label: 'American Samoa', code: 'AS' },
    { id: 'AT', label: 'Austria', code: 'AT' },
    { id: 'AU', label: 'Australia', code: 'AU' },
    { id: 'AW', label: 'Aruba', code: 'AW' },
    { id: 'AX', label: 'Åland Islands', code: 'AX' },
    { id: 'AZ', label: 'Azerbaijan', code: 'AZ' },
    { id: 'BA', label: 'Bosnia and Herzegovina', code: 'BA' },
    { id: 'BB', label: 'Barbados', code: 'BB' },
    { id: 'BD', label: 'Bangladesh', code: 'BD' },
    { id: 'BE', label: 'Belgium', code: 'BE' },
    { id: 'BF', label: 'Burkina Faso', code: 'BF' },
    { id: 'BG', label: 'Bulgaria', code: 'BG' },
    { id: 'BH', label: 'Bahrain', code: 'BH' },
    { id: 'BI', label: 'Burundi', code: 'BI' },
    { id: 'BJ', label: 'Benin', code: 'BJ' },
    { id: 'BL', label: 'Saint Barthélemy', code: 'BL' },
    { id: 'BM', label: 'Bermuda', code: 'BM' },
    { id: 'BN', label: 'Brunei Darussalam', code: 'BN' },
    { id: 'BO', label: 'Bolivia', code: 'BO' },
    { id: 'BQ', label: 'Bonaire, Sint Eustatius and Saba', code: 'BQ' },
    { id: 'BR', label: 'Brazil', code: 'BR' },
    { id: 'BS', label: 'Bahamas', code: 'BS' },
    { id: 'BT', label: 'Bhutan', code: 'BT' },
    { id: 'BV', label: 'Bouvet Island', code: 'BV' },
    { id: 'BW', label: 'Botswana', code: 'BW' },
    { id: 'BY', label: 'Belarus', code: 'BY' },
    { id: 'BZ', label: 'Belize', code: 'BZ' },
    { id: 'CA', label: 'Canada', code: 'CA' },
    { id: 'CC', label: 'Cocos (Keeling) Islands', code: 'CC' },
    { id: 'CD', label: 'Congo, Democratic Republic of the', code: 'CD' },
    { id: 'CF', label: 'Central African Republic', code: 'CF' },
    { id: 'CG', label: 'Congo', code: 'CG' },
    { id: 'CH', label: 'Switzerland', code: 'CH' },
    { id: 'CI', label: 'Côte d\'Ivoire', code: 'CI' },
    { id: 'CK', label: 'Cook Islands', code: 'CK' },
    { id: 'CL', label: 'Chile', code: 'CL' },
    { id: 'CM', label: 'Cameroon', code: 'CM' },
    { id: 'CN', label: 'China', code: 'CN' },
    { id: 'CO', label: 'Colombia', code: 'CO' },
    { id: 'CR', label: 'Costa Rica', code: 'CR' },
    { id: 'CU', label: 'Cuba', code: 'CU' },
    { id: 'CV', label: 'Cabo Verde', code: 'CV' },
    { id: 'CW', label: 'Curaçao', code: 'CW' },
    { id: 'CX', label: 'Christmas Island', code: 'CX' },
    { id: 'CY', label: 'Cyprus', code: 'CY' },
    { id: 'CZ', label: 'Czech Republic', code: 'CZ' },
    { id: 'DE', label: 'Germany', code: 'DE' },
    { id: 'DJ', label: 'Djibouti', code: 'DJ' },
    { id: 'DK', label: 'Denmark', code: 'DK' },
    { id: 'DM', label: 'Dominica', code: 'DM' },
    { id: 'DO', label: 'Dominican Republic', code: 'DO' },
    { id: 'DZ', label: 'Algeria', code: 'DZ' },
    { id: 'EC', label: 'Ecuador', code: 'EC' },
    { id: 'EE', label: 'Estonia', code: 'EE' },
    { id: 'EG', label: 'Egypt', code: 'EG' },
    { id: 'EH', label: 'Western Sahara', code: 'EH' },
    { id: 'ER', label: 'Eritrea', code: 'ER' },
    { id: 'ES', label: 'Spain', code: 'ES' },
    { id: 'ET', label: 'Ethiopia', code: 'ET' },
    { id: 'FI', label: 'Finland', code: 'FI' },
    { id: 'FJ', label: 'Fiji', code: 'FJ' },
    { id: 'FK', label: 'Falkland Islands (Malvinas)', code: 'FK' },
    { id: 'FM', label: 'Micronesia, Federated States of', code: 'FM' },
    { id: 'FO', label: 'Faroe Islands', code: 'FO' },
    { id: 'FR', label: 'France', code: 'FR' },
    { id: 'GA', label: 'Gabon', code: 'GA' },
    { id: 'GB', label: 'United Kingdom', code: 'GB' },
    { id: 'GD', label: 'Grenada', code: 'GD' },
    { id: 'GE', label: 'Georgia', code: 'GE' },
    { id: 'GF', label: 'French Guiana', code: 'GF' },
    { id: 'GG', label: 'Guernsey', code: 'GG' },
    { id: 'GH', label: 'Ghana', code: 'GH' },
    { id: 'GI', label: 'Gibraltar', code: 'GI' },
    { id: 'GL', label: 'Greenland', code: 'GL' },
    { id: 'GM', label: 'Gambia', code: 'GM' },
    { id: 'GN', label: 'Guinea', code: 'GN' },
    { id: 'GP', label: 'Guadeloupe', code: 'GP' },
    { id: 'GQ', label: 'Equatorial Guinea', code: 'GQ' },
    { id: 'GR', label: 'Greece', code: 'GR' },
    { id: 'GS', label: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { id: 'GT', label: 'Guatemala', code: 'GT' },
    { id: 'GU', label: 'Guam', code: 'GU' },
    { id: 'GW', label: 'Guinea-Bissau', code: 'GW' },
    { id: 'GY', label: 'Guyana', code: 'GY' },
    { id: 'HK', label: 'Hong Kong', code: 'HK' },
    { id: 'HM', label: 'Heard Island and McDonald Islands', code: 'HM' },
    { id: 'HN', label: 'Honduras', code: 'HN' },
    { id: 'HR', label: 'Croatia', code: 'HR' },
    { id: 'HT', label: 'Haiti', code: 'HT' },
    { id: 'HU', label: 'Hungary', code: 'HU' },
    { id: 'ID', label: 'Indonesia', code: 'ID' },
    { id: 'IE', label: 'Ireland', code: 'IE' },
    { id: 'IL', label: 'Israel', code: 'IL' },
    { id: 'IM', label: 'Isle of Man', code: 'IM' },
    { id: 'IN', label: 'India', code: 'IN' },
    { id: 'IO', label: 'British Indian Ocean Territory', code: 'IO' },
    { id: 'IQ', label: 'Iraq', code: 'IQ' },
    { id: 'IR', label: 'Iran, Islamic Republic of', code: 'IR' },
    { id: 'IS', label: 'Iceland', code: 'IS' },
    { id: 'IT', label: 'Italy', code: 'IT' },
    { id: 'JE', label: 'Jersey', code: 'JE' },
    { id: 'JM', label: 'Jamaica', code: 'JM' },
    { id: 'JO', label: 'Jordan', code: 'JO' },
    { id: 'JP', label: 'Japan', code: 'JP' },
    { id: 'KE', label: 'Kenya', code: 'KE' },
    { id: 'KG', label: 'Kyrgyzstan', code: 'KG' },
    { id: 'KH', label: 'Cambodia', code: 'KH' },
    { id: 'KI', label: 'Kiribati', code: 'KI' },
    { id: 'KM', label: 'Comoros', code: 'KM' },
    { id: 'KN', label: 'Saint Kitts and Nevis', code: 'KN' },
    { id: 'KP', label: 'Korea, Democratic People\'s Republic of', code: 'KP' },
    { id: 'KR', label: 'Korea, Republic of', code: 'KR' },
    { id: 'KW', label: 'Kuwait', code: 'KW' },
    { id: 'KY', label: 'Cayman Islands', code: 'KY' },
    { id: 'KZ', label: 'Kazakhstan', code: 'KZ' },
    { id: 'LA', label: 'Lao People\'s Democratic Republic', code: 'LA' },
    { id: 'LB', label: 'Lebanon', code: 'LB' },
    { id: 'LC', label: 'Saint Lucia', code: 'LC' },
    { id: 'LI', label: 'Liechtenstein', code: 'LI' },
    { id: 'LK', label: 'Sri Lanka', code: 'LK' },
    { id: 'LR', label: 'Liberia', code: 'LR' },
    { id: 'LS', label: 'Lesotho', code: 'LS' },
    { id: 'LT', label: 'Lithuania', code: 'LT' },
    { id: 'LU', label: 'Luxembourg', code: 'LU' },
    { id: 'LV', label: 'Latvia', code: 'LV' },
    { id: 'LY', label: 'Libya', code: 'LY' },
    { id: 'MA', label: 'Morocco', code: 'MA' },
    { id: 'MC', label: 'Monaco', code: 'MC' },
    { id: 'MD', label: 'Moldova, Republic of', code: 'MD' },
    { id: 'ME', label: 'Montenegro', code: 'ME' },
    { id: 'MF', label: 'Saint Martin (French part)', code: 'MF' },
    { id: 'MG', label: 'Madagascar', code: 'MG' },
    { id: 'MH', label: 'Marshall Islands', code: 'MH' },
    { id: 'MK', label: 'North Macedonia', code: 'MK' },
    { id: 'ML', label: 'Mali', code: 'ML' },
    { id: 'MM', label: 'Myanmar', code: 'MM' },
    { id: 'MN', label: 'Mongolia', code: 'MN' },
    { id: 'MO', label: 'Macao', code: 'MO' },
    { id: 'MP', label: 'Northern Mariana Islands', code: 'MP' },
    { id: 'MQ', label: 'Martinique', code: 'MQ' },
    { id: 'MR', label: 'Mauritania', code: 'MR' },
    { id: 'MS', label: 'Montserrat', code: 'MS' },
    { id: 'MT', label: 'Malta', code: 'MT' },
    { id: 'MU', label: 'Mauritius', code: 'MU' },
    { id: 'MV', label: 'Maldives', code: 'MV' },
    { id: 'MW', label: 'Malawi', code: 'MW' },
    { id: 'MX', label: 'Mexico', code: 'MX' },
    { id: 'MY', label: 'Malaysia', code: 'MY' },
    { id: 'MZ', label: 'Mozambique', code: 'MZ' },
    { id: 'NA', label: 'Namibia', code: 'NA' },
    { id: 'NC', label: 'New Caledonia', code: 'NC' },
    { id: 'NE', label: 'Niger', code: 'NE' },
    { id: 'NF', label: 'Norfolk Island', code: 'NF' },
    { id: 'NG', label: 'Nigeria', code: 'NG' },
    { id: 'NI', label: 'Nicaragua', code: 'NI' },
    { id: 'NL', label: 'Netherlands', code: 'NL' },
    { id: 'NO', label: 'Norway', code: 'NO' },
    { id: 'NP', label: 'Nepal', code: 'NP' },
    { id: 'NR', label: 'Nauru', code: 'NR' },
    { id: 'NU', label: 'Niue', code: 'NU' },
    { id: 'NZ', label: 'New Zealand', code: 'NZ' },
    { id: 'OM', label: 'Oman', code: 'OM' },
    { id: 'PA', label: 'Panama', code: 'PA' },
    { id: 'PE', label: 'Peru', code: 'PE' },
    { id: 'PF', label: 'French Polynesia', code: 'PF' },
    { id: 'PG', label: 'Papua New Guinea', code: 'PG' },
    { id: 'PH', label: 'Philippines', code: 'PH' },
    { id: 'PK', label: 'Pakistan', code: 'PK' },
    { id: 'PL', label: 'Poland', code: 'PL' },
    { id: 'PM', label: 'Saint Pierre and Miquelon', code: 'PM' },
    { id: 'PN', label: 'Pitcairn', code: 'PN' },
    { id: 'PR', label: 'Puerto Rico', code: 'PR' },
    { id: 'PS', label: 'Palestine, State of', code: 'PS' },
    { id: 'PT', label: 'Portugal', code: 'PT' },
    { id: 'PW', label: 'Palau', code: 'PW' },
    { id: 'PY', label: 'Paraguay', code: 'PY' },
    { id: 'QA', label: 'Qatar', code: 'QA' },
    { id: 'RE', label: 'Réunion', code: 'RE' },
    { id: 'RO', label: 'Romania', code: 'RO' },
    { id: 'RS', label: 'Serbia', code: 'RS' },
    { id: 'RU', label: 'Russian Federation', code: 'RU' },
    { id: 'RW', label: 'Rwanda', code: 'RW' },
    { id: 'SA', label: 'Saudi Arabia', code: 'SA' },
    { id: 'SB', label: 'Solomon Islands', code: 'SB' },
    { id: 'SC', label: 'Seychelles', code: 'SC' },
    { id: 'SD', label: 'Sudan', code: 'SD' },
    { id: 'SE', label: 'Sweden', code: 'SE' },
    { id: 'SG', label: 'Singapore', code: 'SG' },
    { id: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha', code: 'SH' },
    { id: 'SI', label: 'Slovenia', code: 'SI' },
    { id: 'SJ', label: 'Svalbard and Jan Mayen', code: 'SJ' },
    { id: 'SK', label: 'Slovakia', code: 'SK' },
    { id: 'SL', label: 'Sierra Leone', code: 'SL' },
    { id: 'SM', label: 'San Marino', code: 'SM' },
    { id: 'SN', label: 'Senegal', code: 'SN' },
    { id: 'SO', label: 'Somalia', code: 'SO' },
    { id: 'SR', label: 'Suriname', code: 'SR' },
    { id: 'SS', label: 'South Sudan', code: 'SS' },
    { id: 'ST', label: 'Sao Tome and Principe', code: 'ST' },
    { id: 'SV', label: 'El Salvador', code: 'SV' },
    { id: 'SX', label: 'Sint Maarten (Dutch part)', code: 'SX' },
    { id: 'SY', label: 'Syrian Arab Republic', code: 'SY' },
    { id: 'SZ', label: 'Eswatini', code: 'SZ' },
    { id: 'TC', label: 'Turks and Caicos Islands', code: 'TC' },
    { id: 'TD', label: 'Chad', code: 'TD' },
    { id: 'TF', label: 'French Southern Territories', code: 'TF' },
    { id: 'TG', label: 'Togo', code: 'TG' },
    { id: 'TH', label: 'Thailand', code: 'TH' },
    { id: 'TJ', label: 'Tajikistan', code: 'TJ' },
    { id: 'TK', label: 'Tokelau', code: 'TK' },
    { id: 'TL', label: 'Timor-Leste', code: 'TL' },
    { id: 'TM', label: 'Turkmenistan', code: 'TM' },
    { id: 'TN', label: 'Tunisia', code: 'TN' },
    { id: 'TO', label: 'Tonga', code: 'TO' },
    { id: 'TR', label: 'Turkey', code: 'TR' },
    { id: 'TT', label: 'Trinidad and Tobago', code: 'TT' },
    { id: 'TV', label: 'Tuvalu', code: 'TV' },
    { id: 'TW', label: 'Taiwan, Province of China', code: 'TW' },
    { id: 'TZ', label: 'Tanzania, United Republic of', code: 'TZ' },
    { id: 'UA', label: 'Ukraine', code: 'UA' },
    { id: 'UG', label: 'Uganda', code: 'UG' },
    { id: 'UM', label: 'United States Minor Outlying Islands', code: 'UM' },
    { id: 'US', label: 'United States', code: 'US' },
    { id: 'UY', label: 'Uruguay', code: 'UY' },
    { id: 'UZ', label: 'Uzbekistan', code: 'UZ' },
    { id: 'VA', label: 'Holy See (Vatican City State)', code: 'VA' },
    { id: 'VC', label: 'Saint Vincent and the Grenadines', code: 'VC' },
    { id: 'VE', label: 'Venezuela, Bolivarian Republic of', code: 'VE' },
    { id: 'VG', label: 'Virgin Islands, British', code: 'VG' },
    { id: 'VI', label: 'Virgin Islands, U.S.', code: 'VI' },
    { id: 'VN', label: 'Viet Nam', code: 'VN' },
    { id: 'VU', label: 'Vanuatu', code: 'VU' },
    { id: 'WF', label: 'Wallis and Futuna', code: 'WF' },
    { id: 'WS', label: 'Samoa', code: 'WS' },
    { id: 'YE', label: 'Yemen', code: 'YE' },
    { id: 'YT', label: 'Mayotte', code: 'YT' },
    { id: 'ZA', label: 'South Africa', code: 'ZA' },
    { id: 'ZM', label: 'Zambia', code: 'ZM' },
    { id: 'ZW', label: 'Zimbabwe', code: 'ZW' },
];

// Paesi più comuni per il trading internazionale (per default/suggerimenti)
export const popularTradingCountries: Country[] = [
    { id: 'US', label: 'United States', code: 'US' },
    { id: 'CN', label: 'China', code: 'CN' },
    { id: 'DE', label: 'Germany', code: 'DE' },
    { id: 'JP', label: 'Japan', code: 'JP' },
    { id: 'GB', label: 'United Kingdom', code: 'GB' },
    { id: 'FR', label: 'France', code: 'FR' },
    { id: 'IT', label: 'Italy', code: 'IT' },
    { id: 'NL', label: 'Netherlands', code: 'NL' },
    { id: 'KR', label: 'Korea, Republic of', code: 'KR' },
    { id: 'CA', label: 'Canada', code: 'CA' },
    { id: 'IN', label: 'India', code: 'IN' },
    { id: 'SG', label: 'Singapore', code: 'SG' },
    { id: 'ES', label: 'Spain', code: 'ES' },
    { id: 'BE', label: 'Belgium', code: 'BE' },
    { id: 'CH', label: 'Switzerland', code: 'CH' },
    { id: 'AU', label: 'Australia', code: 'AU' },
    { id: 'BR', label: 'Brazil', code: 'BR' },
    { id: 'MX', label: 'Mexico', code: 'MX' },
    { id: 'TH', label: 'Thailand', code: 'TH' },
    { id: 'MY', label: 'Malaysia', code: 'MY' },
];
